<div class="default-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-row content">
    <div class="flex flex-col justify-between w-100-percent">
      <div class="flex flex-row w-100-percent">
        <h1 class="flex-auto flex-wrap mat-headline-5 mb-14 fw-600 mr-98">{{title}}</h1>
        <mat-icon svgIcon="close" class="justify-items-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
      </div>
      <div class="mat-subtitle-2 fw-400 mb-24" [innerHtml]="message"></div>
      <div class="flex flex-row justify-end w-100-percent">
        <button class="white mr-12" [matDialogClose]="false">{{'DIALOG.CANCEL'| transloco}}</button>
        <button class="accent" [matDialogClose]="true">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</div>
